/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * GENERAL LAYOUT FUNCTIONALITY
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

import { viewportDimensions } from '/helpers/window'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE HEADER JAVASCRIPT
 * Header Scroll on Mobile-size only
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

let isMobileView = viewportDimensions().width < _MEDIA_SMALL ? true : false
window.addEventListener('resize', () => isMobileView = viewportDimensions().width < _MEDIA_SMALL ? true : false)
let lastScrollTop = 0
const delta = 5
const $html = document.querySelector('html')
const $header = document.querySelector('.header')
let headerHeight = $header.clientHeight

window.addEventListener('scroll', _.throttle(() => {
	if (!isMobileView) { return }
	const scrollTop = window.pageYOffset
	// make sure they scroll more than delta
	if (Math.abs(lastScrollTop - scrollTop) <= delta + headerHeight) { return }
	if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
		$html.classList.add('header-up') // scroll down
	} else {
		$html.classList.remove('header-up') // scroll up
	}
	lastScrollTop = scrollTop
}, 100))
window.addEventListener('resize', () => headerHeight = $header.clientHeight)

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE HEADER JAVASCRIPT
 * toggle main navigation on medium and small,
 * but not large
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $$mainMenuToggles = document.querySelectorAll('.dropdown-menu [aria-controls]')
_.each($$mainMenuToggles, $toggle => {
	$toggle.addEventListener('click', function() {
		const $section = $toggle.closest('.section')
		const expanded = $section.getAttribute('aria-expanded') === 'true'
		$section.setAttribute('aria-expanded', !expanded)
	})
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Main & Search Navigation
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $menuToggle = document.querySelector('.header .main-menu .icon')
const $menuDropdown = document.querySelector('.header .dropdown-menu')
const $searchToggle = document.querySelector('.header .search .icon')
const $searchDropdown = document.querySelector('.header .dropdown-search')
const $mainSearch = document.querySelector('.header #main-search')
function menuItemToggle(menuClass, $toggle, $dropdown) {
	return function(/* event */) {
		const expanded = $toggle.getAttribute('aria-expanded') === 'true'
		if (expanded) {
			// it is open, so close it
			$html.classList.remove('menu-item-open')
			$html.classList.remove(menuClass)
			$dropdown.setAttribute('aria-hidden', 'true')
			$toggle.setAttribute('aria-expanded', !expanded)
			$dropdown.classList.add('visibility-hidden')
		} else {
			if ($html.classList.contains('menu-item-open')) {
				// it is open elsewhere, so close that first
				$html.classList.add('menu-stable')
				setTimeout(() => {
					$html.classList.remove('menu-stable')
				}, 350)
				// resetting everything
				$html.classList.remove('menu-main-open')
				$html.classList.remove('menu-search-open')
				$menuToggle.setAttribute('aria-expanded', 'false')
				$searchToggle.setAttribute('aria-expanded', 'false')
				$menuDropdown.setAttribute('aria-hidden', 'true')
				$searchDropdown.setAttribute('aria-hidden', 'true')
				$menuDropdown.classList.add('visibility-hidden')
				$searchDropdown.classList.add('visibility-hidden')
				// now open the menu
				$html.classList.add(menuClass)
				$dropdown.removeAttribute('aria-hidden')
				$toggle.setAttribute('aria-expanded', !expanded)
				$dropdown.classList.remove('visibility-hidden')
				if (menuClass === 'menu-search-open') { $mainSearch.focus() }
			} else {
				// it is not open elsewhere, so open it
				$html.classList.add('menu-item-open')
				$html.classList.add(menuClass)
				$dropdown.removeAttribute('aria-hidden')
				$toggle.setAttribute('aria-expanded', !expanded)
				$dropdown.classList.remove('visibility-hidden')
				if (menuClass === 'menu-search-open') { $mainSearch.focus() }
			}
		}
	}
}
$menuToggle.addEventListener('click', menuItemToggle('menu-main-open', $menuToggle, $menuDropdown))
$searchToggle.addEventListener('click', menuItemToggle('menu-search-open', $searchToggle, $searchDropdown))

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Sub Navigation
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $subNavToggle = document.querySelector('.nav-sub-bar [aria-expanded]')
if ($subNavToggle) {
	const $subNavDropdown = document.querySelector('.nav-sub-bar .dropdown')
	$subNavToggle.addEventListener('click', function() {
		const expanded = $subNavToggle.getAttribute('aria-expanded') === 'true'
		if (expanded) {
			$subNavDropdown.setAttribute('aria-hidden', 'true')
			$subNavDropdown.classList.add('visibility-hidden')
		} else {
			$subNavDropdown.removeAttribute('aria-hidden')
			$subNavDropdown.classList.remove('visibility-hidden')
		}
		$subNavToggle.setAttribute('aria-expanded', !expanded)
	})
	const $subNav = document.querySelector('.nav-sub')
	document.addEventListener('click', function(event) {
		if (!$subNav.contains(event.target)) {
			$subNavDropdown.setAttribute('aria-hidden', 'true')
			$subNavToggle.setAttribute('aria-expanded', 'false')
			$subNavDropdown.classList.add('visibility-hidden')
		}
	})
}

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE FOOTER JAVASCRIPT
 * the use case is here for changing functionality
 * at different responsive dimensions to
 * match CSS responsive dimensions
 * 
 * FOR EXAMPLE, button roles in the footer
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $$footerGroups = document.querySelectorAll('.footer [aria-expanded]')
function responsiveFooter() {
	const isWeirdSize = viewportDimensions().width >= _MEDIA_WEIRD
	_.each($$footerGroups, $group => {
		if (isWeirdSize) {
			const expanded = $group.getAttribute('temp-expanded')
			if (expanded) {
				$group.setAttribute('aria-expanded', expanded)
			}
			$group.removeAttribute('temp-expanded')
		} else {
			const expanded = $group.getAttribute('aria-expanded')
			if (expanded) {
				$group.setAttribute('temp-expanded', expanded)
			}
			$group.removeAttribute('aria-expanded')
		}
	})
}
responsiveFooter()
window.addEventListener('resize', () => responsiveFooter())

// toggling on each section
const $$footerToggles = document.querySelectorAll('.footer [aria-controls]')
_.each($$footerToggles, $toggle => {
	$toggle.addEventListener('click', function() {
		const $group = $toggle.closest('.group')
		const expanded = $group.getAttribute('aria-expanded') === 'true'
		$group.setAttribute('aria-expanded', !expanded)
	})
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * accessibility
 * Tab loops for main and search menus
 * (both forward and backward loops)
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $menuFocusFirst = document.querySelector('#menu-focus-first')
const $menuFocusLast = document.querySelector('#menu-focus-last')
$menuFocusLast.addEventListener('keydown', event => {
	if (!event.shiftKey && event.keyCode === 9) {
		event.preventDefault()
		$menuFocusFirst.focus()
	}
})
$menuFocusFirst.addEventListener('keydown', event => {
	if (event.shiftKey && event.keyCode === 9 && !$menuDropdown.classList.contains('visibility-hidden')) {
		event.preventDefault()
		$menuFocusLast.focus()
	}
})
const $searchFocusFirst = document.querySelector('#search-focus-first')
const $searchFocusLast = document.querySelector('#search-focus-last')
$searchFocusLast.addEventListener('keydown', event => {
	if (!event.shiftKey && event.keyCode === 9) {
		event.preventDefault()
		$searchFocusFirst.focus()
	}
})
$searchFocusFirst.addEventListener('keydown', event => {
	if (event.shiftKey && event.keyCode === 9 && !$searchDropdown.classList.contains('visibility-hidden')) {
		event.preventDefault()
		$searchFocusLast.focus()
	}
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE SIZING FOR .cta-2col-bg
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $$preWraps = document.querySelectorAll('.cta-2col-bg .pre-wrap')
function responsivePreWraps() {
	_.each($$preWraps, $wrap => $wrap.removeAttribute('style'))
	if (viewportDimensions().width >= _MEDIA_MEDIUM) {
		let height = 0
		_.each($$preWraps, $wrap => height = Math.max(height, $wrap.getBoundingClientRect().height))
		_.each($$preWraps, $wrap => $wrap.style.height = height + 'px')
	}
}
responsivePreWraps()
window.addEventListener('resize', () => responsivePreWraps())


/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Jump to top of page button in footer
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

document.querySelector('#back-to-top-footer').addEventListener('click', event => {
	event.preventDefault()
	window.scroll(0, 0)
})
